import { render, staticRenderFns } from "./muokkaa-ilmoitusta.vue?vue&type=template&id=f2bf03c2&scoped=true&"
import script from "./muokkaa-ilmoitusta.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-ilmoitusta.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-ilmoitusta.vue?vue&type=style&index=0&id=f2bf03c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bf03c2",
  null
  
)

export default component.exports